import { render, staticRenderFns } from "./VirtualSpecialKeys.vue?vue&type=template&id=3f54f869&scoped=true&"
import script from "./VirtualSpecialKeys.vue?vue&type=script&lang=js&"
export * from "./VirtualSpecialKeys.vue?vue&type=script&lang=js&"
import style0 from "./VirtualSpecialKeys.vue?vue&type=style&index=0&id=3f54f869&lang=scss&scoped=true&"
import style1 from "./VirtualSpecialKeys.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f54f869",
  null
  
)

export default component.exports